<template>
  <div class="text-center">
    <el-image 
      src="/static/images/default-shopcart.png" 
      loading="lazy" 
      alt="購物車還沒有東西"
      :style="{ aspectRatio: 200 / 136, width: `${width}px` }"
      class="mb-3"
    />
    <h4>{{ $t("carts.empty1") }}</h4>
    <h4>{{ $t("carts.empty2") }}</h4>
    <div class="mt-2"><slot /></div>
  </div>
</template>

<script>
// import {  } from "vue";
import { useI18n } from "vue-i18n";

export default {
  name: "EmptyCartImage",
  props: {
    width: {
      type: Number,
      default: 200,
    }
  },
  setup(props) {
    const { t, n, locale } = useI18n();

    return {

    }
  }
}
</script>
